import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import styled from 'styled-components';

const AdminContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-color);
`;

const Sidebar = styled.aside`
  width: 250px;
  background-color: var(--card-bg);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
`;

const SidebarHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color);
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  font-size: 1.25rem;
  color: var(--primary-color);
`;

const NavMenu = styled.nav`
  padding: 1rem 0;
  flex: 1;
`;

const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: var(--hover-color);
    color: var(--text-color);
  }
  
  &.active {
    background-color: var(--primary-light);
    color: var(--primary-color);
    font-weight: 500;
    border-right: 3px solid var(--primary-color);
  }
`;

const SidebarFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem;
  background-color: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: var(--hover-color);
    color: var(--text-color);
  }
`;

const Content = styled.main`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
`;

const AdminLayout = () => {
  const { logout, user } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <AdminContainer>
      <Sidebar>
        <SidebarHeader>
          <Logo>
            <span>🍓</span>
            <span>Admin Panel</span>
          </Logo>
        </SidebarHeader>
        
        <NavMenu>
          <NavItem to="/admin/dashboard">Dashboard</NavItem>
          <NavItem to="/admin/users">User Management</NavItem>
          <NavItem to="/admin/settings">Settings</NavItem>
          <NavItem to="/">Return to App</NavItem>
        </NavMenu>
        
        <SidebarFooter>
          <div style={{ marginBottom: '0.5rem', fontSize: '0.875rem' }}>
            Logged in as: {user?.username || 'Admin'}
          </div>
          <LogoutButton onClick={handleLogout}>
            Logout
          </LogoutButton>
        </SidebarFooter>
      </Sidebar>
      
      <Content>
        <Outlet />
      </Content>
    </AdminContainer>
  );
};

export default AdminLayout;
